module.exports = __webpack_public_path__ + "img/ape-weekly-winner.f1c01b7a.gif";